import { Box } from '@betterment/samba-react';

import Docusign, { DocusignSessionEndEventProps } from './Docusign';

interface SigningInterfaceProps {
  signablePackageId: string;
  docusignClientId: string;
  docusignSignatureURL: string;
  onSessionEnd: (event: DocusignSessionEndEventProps) => void;
}

const SigningInterface: React.FC<SigningInterfaceProps> = ({
  docusignClientId,
  docusignSignatureURL,
  onSessionEnd,
}) => {
  return (
    <Box css={{ mb: 'space.400' }}>
      <Docusign
        docusignClientId={docusignClientId}
        docusignSignatureURL={docusignSignatureURL}
        onSessionEnd={onSessionEnd}
      />
    </Box>
  );
};

export default SigningInterface;
